import React, { useEffect } from 'react';
import './PaymentDetails.css';
import PropTypes from "prop-types";
import { getCartProducts, getTotalCartAfterProductDiscount } from "../../../reducers";
import {
    cancelOrderUser,
    checkout,
    confirmOrder,
    getAllProducts,
} from "../../../actions";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { MDBCol, MDBContainer, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import ProductOnPayment from "./ProductOnPayment"; // Import the component for displaying products on payment page
import "../../../fonts/fonts.css";
import { useState } from 'react';
import ConfirmationMessage from './ConfirmationMessage';


const PaymentDetails = ({ products, total, getAllProducts, cancelOrderUser, confirmOrder }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { order } = location.state;
    const orderItems = order.orderItems;
    const [showConfirmationBox, setShowConfirmationBox] = useState(false);


    //console.log("order in payment", order);

    useEffect(() => {
        // Dispatch the getAllProducts action when the component mounts
        getAllProducts();
    }, [getAllProducts]);

    // We assume order.totalAmountCartAfterProductDiscount exists as total here.
    // const cartTotal = parseFloat(order.totalWithDiscountsAndShipping);
    const shippingPrice = parseFloat(order.shippingMethodPrice);

    const onConfirmOrder = () => {
        confirmOrder(order.orderId)
            .then(msg => {
                // //console.log(msg);
                // navigate('/');
                setShowConfirmationBox(true); // pokaži box
            })
            .catch(error => {
                console.error('Checkout error:', error);
            });
    };

    const onCancelOrder = () => {
        cancelOrderUser(order.orderId)
            .then(msg => {
                //console.log(msg);
                navigate('/cart');
            })
            .catch(error => {
                console.error('Checkout error:', error);
            });
    };

    const hasProducts = orderItems.length > 0;
    const nodes = hasProducts ? (
        orderItems.map(orderItem =>
            <ProductOnPayment
                productName={orderItem.product.productName}
                brandName={orderItem.product.brandName}
                image={orderItem.product.image}
                price={orderItem.product.price}
                specialPrice={orderItem.orderedProductPrice}
                quantity={orderItem.quantity}
                productId={orderItem.product.productId}
                key={orderItem.product.productId}
            />
        )
    ) : (
        <em>Please add some products to cart.</em>
    );

    return (
        <div style={{ paddingTop: "10rem" }}>
            {order.paymentMethod === "Transakcijski račun" &&
                <div className="naplata-container">
                    <div className="order-confirmation font-tiskani" style={{ padding: "1.5rem" }}>
                        <h2>Naplata</h2>
                        <p>
                            Kako biste dovršili kupnju, molimo Vas da <strong>potvrdite narudžbu</strong> klikom na gumb na dnu stranice.
                        </p>
                        <p>
                            Nakon potvrde, na Vašu e-mail adresu ćemo poslati:
                        </p>
                        <ul>
                            <li>potvrdu narudžbe</li>
                            <li>upute za plaćanje</li>
                            <li>račun</li>
                        </ul>
                        <p>Hvala Vam na povjerenju i narudžbi!</p>
                    </div>
                </div>
            }
            {order.paymentMethod === "Plaćanje pouzećem" &&
                <div className="naplata-container">
                    <h2 className="font-tiskani">Naplata</h2>
                    <p className="font-tiskani">
                        Vaša narudžba je zaprimljena. Nakon pregledanih podataka, molimo Vas da potvrdite svoju narudžbu pritiskom na gumb na dnu stranice.
                        Naplata će se izvršiti pri dostavi narudžbe kurirskom službom. Potvrda o narudžbi će biti poslana na Vašu email adresu. Hvala Vam na narudžbi!
                    </p>
                </div>
            }

            {/* Order Details Section */}
            <div className="payment-details-container">
                <h4 className="font-tiskani">Detalji narudžbe</h4>
                <table className="payment-details-table">
                    <tbody>
                    {/*<tr>*/}
                    {/*    <td className="font-tiskani"><strong>Broj narudžbe:</strong></td>*/}
                    {/*    <td className="font-tiskani">{order.orderId}</td>*/}
                    {/*</tr>*/}
                    <tr>
                        <td className="font-tiskani"><strong>Iznos:</strong></td>
                        <td className="font-tiskani">€{order.totalWithDiscountsAndShipping.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td className="font-tiskani"><strong>Datum:</strong></td>
                        <td className="font-tiskani">{order.orderDate}</td>
                    </tr>
                    <tr>
                        <td className="font-tiskani"><strong>Email adresa:</strong></td>
                        <td className="font-tiskani">{order.email}</td>
                    </tr>
                    <tr>
                        <td className="font-tiskani"><strong>Način plaćanja:</strong></td>
                        <td className="font-tiskani">{order.paymentMethod}</td>
                    </tr>
                    {/* New Address Row */}
                    <tr>
                        <td className="font-tiskani"><strong>Adresa dostave:</strong></td>
                        <td className="font-tiskani">
                            {order.address.street}, {order.address.city} - {order.address.postcode}, {order.address.country}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>


            {order.r1Invoice && (
                <div className="payment-details-container">
                    <h4 className="font-tiskani">Podaci za R1 račun</h4>
                    <table className="payment-details-table">
                        <tbody>
                        <tr>
                            <td className="font-tiskani"><strong>Ime tvrtke:</strong></td>
                            <td className="font-tiskani">{order.r1CompanyName}</td>
                        </tr>
                        <tr>
                            <td className="font-tiskani"><strong>Adresa tvrtke:</strong></td>
                            <td className="font-tiskani">{order.r1Address}, {order.r1City} - {order.r1Postcode}</td>
                        </tr>
                        <tr>
                            <td className="font-tiskani"><strong>OIB tvrtke:</strong></td>
                            <td className="font-tiskani">{order.r1Oib}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            )}


            <section className="h-100 h-custom padding">
                <MDBContainer className="container-cart-1 py-5 h-100 color-white" style={{ justifyContent: "center" }}>
                    <MDBRow className="justify-content-center align-items-center h-100">
                        <MDBCol>
                            <MDBTable responsive>
                                <MDBTableHead>
                                    <tr>
                                        <th scope="col" className="h5 font-tiskani-mali">Košarica</th>
                                        <th scope="col" style={{ textAlign: "center" }} className="h6 font-tiskani-mali">Količina</th>
                                        <th scope="col" style={{ textAlign: "center" }} className="h6 font-tiskani-mali">Cijena</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>{nodes}</MDBTableBody>
                            </MDBTable>
                        </MDBCol>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p className="mb-2 font-tiskani-mali">Ukupno: </p>
                            <p className="mb-2 font-tiskani-mali padding-price">{parseFloat(order.totalAmountCartWithProductDiscountAndDiscount).toFixed(2)}€</p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p className="mb-2 font-tiskani-mali">Dostava: </p>
                            <p className="mb-2 font-tiskani-mali padding-price">{shippingPrice.toFixed(2)}€</p>
                        </div>
                        <hr style={{ width: '100%', color: 'lightgray', margin: '10px 0' }} />
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p className="mb-2 font-tiskani-mali">Sveukupno: </p>
                            <p className="mb-2 font-tiskani-mali padding-price">{(order.totalWithDiscountsAndShipping).toFixed(2)}€</p>
                        </div>
                    </MDBRow>
                </MDBContainer>
            </section>

            <div style={{ display: "flex", justifyContent: "space-around" }}>
                <button id="button-pay" className="font-tiskani-mali" onClick={onCancelOrder} style={{ margin: "2rem 1rem" }}>
                    Odustani
                </button>
                <button id="button-pay" className="font-tiskani-mali" onClick={onConfirmOrder} style={{ margin: "2rem 1rem" }}>
                    Potvrdi narudžbu
                </button>
                {showConfirmationBox && (
                    <ConfirmationMessage
                        onClose={() => navigate('/home')}
                        paymentMethod={order.paymentMethod} />
                )}
            </div>
        </div>
    );
};

PaymentDetails.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        productId: PropTypes.number.isRequired,
        productName: PropTypes.string.isRequired,
        brandName: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        specialPrice: PropTypes.number.isRequired,
        discount: PropTypes.number.isRequired,
        quantity: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired
    })),
    total: PropTypes.string,
    getAllProducts: PropTypes.func.isRequired,
    checkout: PropTypes.func.isRequired,
    cancelOrderUser: PropTypes.func.isRequired,
    confirmOrder: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    products: getCartProducts(state),
    total: getTotalCartAfterProductDiscount(state)
});

const mapDispatchToProps = {
    getAllProducts,
    checkout,
    cancelOrderUser,
    confirmOrder
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentDetails);
